export default __webpack_public_path__ + "static/media/delete.405d0183.svg";